// --- FULL UPDATED FILE BELOW WITH VALIDATION MERGED ---

import React, { useState, useContext, useEffect } from 'react';
import Cropper from 'react-easy-crop';
import { useParams } from "react-router-dom";
import { AuthContext } from "react-oauth2-code-pkce";
import axios from "axios";
import toast from 'react-hot-toast';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function RegisterMember({ selectedPerson, editMode = false, closeModal, onUpdateMembers }) {
  const { id } = useParams();
  const { token } = useContext(AuthContext);

  const [activeTab, setActiveTab] = useState('Personal');
  const [existingUserMode, setExistingUserMode] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const [formValid, setFormValid] = useState(false);

  const validateForm = () => {
    let newErrors = { firstName: "", lastName: "", email: "" };
    let valid = true;
  if (!existingUserMode) {
    // Email validation (always required)
    if (!formData.personal.email.trim()) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.personal.email)) {
      newErrors.email = "Enter a valid email address.";
      valid = false;
    }
  }

    // Only validate names when NOT linking an existing user
    if (!existingUserMode) {
      if (!formData.personal.firstName.trim()) {
        newErrors.firstName = "First name is required.";
        valid = false;
      }

      if (!formData.personal.lastName.trim()) {
        newErrors.lastName = "Last name is required.";
        valid = false;
      }
    }

    setErrors(newErrors);
    setFormValid(valid);
    return valid;
  };


  const handleNameChange = (e) => {
    handlePersonalInfoChange(e);
    const { id, value } = e.target;

    setErrors(prev => ({
      ...prev,
      [id]: value.trim()
        ? ""
        : id === "firstName"
        ? "First name is required."
        : "Last name is required.",
    }));
  };

  const handleEmailValidationChange = (e) => {
    const value = e.target.value;

    handleEmailChange(e);

    setErrors(prev => ({
      ...prev,
      email:
        value.trim() && !/\S+@\S+\.\S+/.test(value)
          ? "Enter a valid email address."
          : ""
    }));
  };

  const [formData, setFormData] = useState({
    personal: {
      firstName: '',
      lastName: '',
      relationType: 'Child',
      gender: 'Female',
      isAlive: true,
      birthDate: '',
      marriageDate: '',
      deathDate: '',
      linkedUser: '',
      phone: '',
      email: '',
      photo: null,
      croppedPhoto: null,
      croppedFile: null,
    },
    contact: {
      facebook: '',
      twitter: '',
      instagram: '',
      homeTel: '',
      mobile: '',
      website: '',
    },
    biographical: {
      profession: '',
      company: '',
      interests: '',
      bioNotes: '',
      birthPlace: '',
      deathPlace: '',
    },
  });

  const [isFirstMember, setIsFirstMember] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cropping, setCropping] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [emailToInvite, setEmailToInvite] = useState('');

  const relationOptions = ['Child', 'Parent', 'Spouse'];

  useEffect(() => {
    if (!editMode || !selectedPerson) return;

    const [firstName = "", lastName = ""] =
      selectedPerson.name?.split(" ") || [];

    setFormData(prev => ({
      ...prev,
      personal: {
        ...prev.personal,
        firstName,
        lastName,
        gender: selectedPerson.gender || "Female",
        isAlive: selectedPerson.isAlive ?? true,
        birthDate: selectedPerson.dob || "",
        marriageDate: "",
        deathDate: "",
        email: selectedPerson.email || "",
        phone: selectedPerson.phone || "",
        photo: selectedPerson.photo || null,
      },
    }));

    setErrors({ firstName: "", lastName: "", email: "" });
    setFormValid(true);
  }, [editMode, selectedPerson]);

  useEffect(() => {
    if (!editMode || !selectedPerson?.id) return;

    const fetchMemberProfile = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/user/profile/id/${selectedPerson.id}`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );

        const member = res.data?.data || res.data;

        setFormData(prev => ({
          ...prev,
          personal: {
            ...prev.personal,
            email: member.email || "",
            phone: member.homeTel || "",
            gender: member.gender || prev.personal.gender,
            isAlive: member.memberAlive ?? prev.personal.isAlive,
            birthDate: member.birthDate?.value || "",
            marriageDate: member.marriageDate?.value || "",
            deathDate: member.deathDate?.value || "",
            photo:member.avatar && !member.avatar.includes("fileName=null")? member.avatar: null, // ✅ FIX 1
          },
        }));

        setErrors({ firstName: "", lastName: "", email: "" });
        setFormValid(true);
      } catch (err) {
        console.error("Failed to load member profile", err);
      }
    };

    fetchMemberProfile();
  }, [editMode, selectedPerson?.id]);


  // Fetch overview
  useEffect(() => {
    const fetchFamilyOverview = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/family/${id}/overview`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        const overview = response.data;

        if (overview && overview.memberCount === 0) {
          setIsFirstMember(true);
          toast("This is the first member of the family!", {
            duration: 5000,
            style: { background: "#16a34a", color: "#fff" },
          });

          setFormData(prev => ({
            ...prev,
            personal: { ...prev.personal, relationType: "Root" },
          }));
        }
      } catch (err) {
        console.error("Failed to fetch family overview:", err);
      }
    };

    fetchFamilyOverview();
  }, [id, token]);

  const handlePersonalInfoChange = (event) => {
    if (existingUserMode && event.target.id !== 'relationType') return;

    const { id, value, type, checked, files } = event.target;
    if (type === 'file' && files && files[0]) {
      if (existingUserMode) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData(prev => ({
          ...prev,
          personal: {
            ...prev.personal,
            photo: e.target.result,
            croppedPhoto: null,
            croppedFile: null,
          },
        }));
        setCropping(true);
      };
      reader.readAsDataURL(files[0]);
    } else if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        personal: {
          ...prev.personal,
          [id]: checked,
          deathDate: id === 'isAlive' && checked ? '' : prev.personal.deathDate,
        },
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        personal: { ...prev.personal, [id]: value },
      }));
    }

    validateForm();
  };

  const handleContactInfoChange = (event) => {
    const { id, value } = event.target;
    setFormData(prev => ({
      ...prev,
      contact: { ...prev.contact, [id]: value },
    }));
  };

  const handleBiographicalInfoChange = (event) => {
    const { id, value } = event.target;
    setFormData(prev => ({
      ...prev,
      biographical: { ...prev.biographical, [id]: value },
    }));
  };

  const handlePhoneChange = (event) => {
    const { value } = event.target;
    setFormData(prev => ({
      ...prev,
      personal: { ...prev.personal, phone: value },
    }));
  };

  const handleEmailChange = (e) => {
    setFormData(prev => ({
      ...prev,
      personal: { ...prev.personal, email: e.target.value },
    }));
    setExistingUserMode(false);
    toast.dismiss();
  };

  const handleEmailUpdate = async (e) => {
      if (editMode) return; // ✅ STOP email check in edit mode
    const value = e.target.value.trim();
    if (!value || !/\S+@\S+\.\S+/.test(value)) {
      setExistingUserMode(false);
      return;
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/user/check/${encodeURIComponent(value)}`,
        {
          headers: token?.access_token
            ? { Authorization: `Bearer ${token.access_token}` }
            : {},
        }
      );
      

      if (response.data === true) {
        setEmailToInvite(value);
        setExistingUserMode(true);
        setFormValid(true); // ✅ FORCE enable button
        setActiveTab('Personal');

        toast(
          <div className="flex flex-col">
            <p className="font-bold text-white">Existing User Found!</p>
            <p className="text-sm mt-1 text-gray-100">
              A user with email <span className="font-semibold text-white">{value}</span> already exists.
            </p>
          </div>,
          {
            duration: 8000,
            style: { background: "#16a34a", color: "#fff" },
          }
        );
      } else {
        setExistingUserMode(false);
      }
    } catch (error) {
      console.error("Error checking email existence:", error);
      setExistingUserMode(false);
      toast.error('Could not verify email existence. Please try again.');
    }
  };

  const handleAliveToggle = () => {
    setFormData(prev => ({
      ...prev,
      personal: {
        ...prev.personal,
        isAlive: !prev.personal.isAlive,
        deathDate: prev.personal.isAlive ? '' : prev.personal.deathDate,
      },
    }));

    validateForm();
  };

  const handleCropComplete = (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  async function getCroppedImg(imageSrc, crop) {
    const createImage = (url) =>
      new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', (error) => reject(error));
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = url;
      });

    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        const file = new File([blob], "cropped.jpg", { type: "image/jpeg" });
        resolve(file);
      }, 'image/jpeg');
    });
  }

  const handleCropSave = async () => {
    const croppedFile = await getCroppedImg(formData.personal.photo, croppedAreaPixels);
    const croppedUrl = URL.createObjectURL(croppedFile);

    setFormData(prev => ({
      ...prev,
      personal: {
        ...prev.personal,
        croppedPhoto: croppedUrl,
        croppedFile,
      },
    }));

    setCropping(false);
  };

  const handleCropCancel = () => {
    setCropping(false);
    setFormData(prev => ({
      ...prev,
      personal: { ...prev.personal, photo: null, croppedPhoto: null, croppedFile: null },
    }));
  };



 const handleUpdateMember = async () => {
  const updateToastId = toast.loading("Updating member...");

  try {
    const payload = new FormData();

    // 🔥 REQUIRED
    payload.append("id", selectedPerson.id);

    // -------- Personal --------
    payload.append("firstName", formData.personal.firstName);
    payload.append("lastName", formData.personal.lastName);
    payload.append("gender", formData.personal.gender);
    payload.append("isAlive", formData.personal.isAlive);
    payload.append("email", formData.personal.email);
    payload.append("phone", formData.personal.phone);

    // -------- Dates (same structure as create) --------
    function buildLocalizedDate(dateString) {
      if (!dateString) return null;

      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      return {
        localized: new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }).format(new Date(dateString)),
        value: dateString,
        culture: "en-US",
        timeZone,
        raw: new Date(dateString).getTime(),
      };
    }

    const birth = buildLocalizedDate(formData.personal.birthDate);
    const marriage = buildLocalizedDate(formData.personal.marriageDate);
    const death = buildLocalizedDate(formData.personal.deathDate);

    if (birth) {
      payload.append("birthDate.localized", birth.localized);
      payload.append("birthDate.value", birth.value);
      payload.append("birthDate.culture", birth.culture);
      payload.append("birthDate.timeZone", birth.timeZone);
      payload.append("birthDate.raw", birth.raw);
    }

    if (marriage) {
      payload.append("marriageDate.localized", marriage.localized);
      payload.append("marriageDate.value", marriage.value);
      payload.append("marriageDate.culture", marriage.culture);
      payload.append("marriageDate.timeZone", marriage.timeZone);
      payload.append("marriageDate.raw", marriage.raw);
    }

    if (death) {
      payload.append("deathDate.localized", death.localized);
      payload.append("deathDate.value", death.value);
      payload.append("deathDate.culture", death.culture);
      payload.append("deathDate.timeZone", death.timeZone);
      payload.append("deathDate.raw", death.raw);
    }

    // -------- Contact --------
    payload.append("facebook", formData.contact.facebook);
    payload.append("twitter", formData.contact.twitter);
    payload.append("instagram", formData.contact.instagram);
    payload.append("homeTel", formData.contact.homeTel);
    payload.append("mobile", formData.contact.mobile);
    payload.append("website", formData.contact.website);

    // -------- Biographical --------
    payload.append("profession", formData.biographical.profession);
    payload.append("company", formData.biographical.company);
    payload.append("interests", formData.biographical.interests);
    payload.append("bioNotes", formData.biographical.bioNotes);
    payload.append("birthPlace", formData.biographical.birthPlace);
    payload.append("deathPlace", formData.biographical.deathPlace);

    // -------- Photo --------
    if (formData.personal.croppedFile) {
      payload.append("photo", formData.personal.croppedFile);
    } else if (formData.personal.photo && !formData.personal.croppedFile) {
      try {
        const res = await fetch(formData.personal.photo);
        const blob = await res.blob();
        const originalFile = new File([blob], "photo.jpg", { type: blob.type });
        payload.append("photo", originalFile);
      } catch (err) {
        console.warn("Failed to include original photo:", err);
      }
    }

    await axios.patch(
      `${API_BASE_URL}/user/profile`,
      payload,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );

    toast.success("Member updated successfully!", { id: updateToastId });

    closeModal();
    onUpdateMembers();
  } catch (err) {
    console.error("Update failed:", err);
    toast.error("Failed to update member.", { id: updateToastId });
  }
};



  const handleSubmit = async (event) => {
    event.preventDefault();
    toast.dismiss();
    // 🔥 EDIT MODE HANDLING (CORRECT PLACE)
    if (editMode) {
      await handleUpdateMember();
      return;
    }
    if (!validateForm()) {
      toast.error("Please fix validation errors.");
      return;
    }

    // ----- existingUserMode unchanged -----
    if (existingUserMode) {
      const linkToastId = toast.loading("Sending invitation to link user...");

      try {
        const response = await axios.post(
          `${API_BASE_URL}/family/linkExistingUser`,
          {
            email: formData.personal.email,
            familyId: id,
            relatedToPersonId: selectedPerson?.id || null,
            relationType: formData.personal.relationType,
          },
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );

        toast.success("Invitation sent successfully!", {
          id: linkToastId,
          duration: 4000,
        });

        closeModal();
        onUpdateMembers(response.data.members || []);
      } catch (err) {
        console.error("Failed to link existing user:", err);
        toast.error("Failed to link existing user.", { id: linkToastId });
      }

      return;
    }

    // -------- NEW MEMBER logic untouched --------
    const registerToastId = toast.loading("Registering new member...");

    try {
      const payload = new FormData();
      payload.append("familyId", id);
      payload.append("relatedToPersonId", selectedPerson?.id || "");
      payload.append("relationType", formData.personal.relationType);
      payload.append("firstName", formData.personal.firstName);
      payload.append("lastName", formData.personal.lastName);
      payload.append("gender", formData.personal.gender);
      payload.append("isAlive", formData.personal.isAlive);

      // *********************************************
      //          NEW DATE LOGIC (PATCHED)
      // *********************************************
      function buildLocalizedDate(dateString) {
        if (!dateString) return null;

        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return {
          localized: new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }).format(new Date(dateString)),
          value: dateString,
          culture: "en-US",
          timeZone,
          raw: new Date(dateString).getTime(),
        };
      }

      const birth = buildLocalizedDate(formData.personal.birthDate);
      const marriage = buildLocalizedDate(formData.personal.marriageDate);
      const death = buildLocalizedDate(formData.personal.deathDate);

      if (birth) {
        payload.append("birthDate.localized", birth.localized);
        payload.append("birthDate.value", birth.value);
        payload.append("birthDate.culture", birth.culture);
        payload.append("birthDate.timeZone", birth.timeZone);
        payload.append("birthDate.raw", birth.raw);
      }

      if (marriage) {
        payload.append("marriageDate.localized", marriage.localized);
        payload.append("marriageDate.value", marriage.value);
        payload.append("marriageDate.culture", marriage.culture);
        payload.append("marriageDate.timeZone", marriage.timeZone);
        payload.append("marriageDate.raw", marriage.raw);
      }

      if (death) {
        payload.append("deathDate.localized", death.localized);
        payload.append("deathDate.value", death.value);
        payload.append("deathDate.culture", death.culture);
        payload.append("deathDate.timeZone", death.timeZone);
        payload.append("deathDate.raw", death.raw);
      }

      // Photo
      if (formData.personal.croppedFile) {
        payload.append("photo", formData.personal.croppedFile);
      } else if (formData.personal.photo && !formData.personal.croppedFile) {
        try {
          const res = await fetch(formData.personal.photo);
          const blob = await res.blob();
          const originalFile = new File([blob], "photo.jpg", { type: blob.type });
          payload.append("photo", originalFile);
        } catch (err) {
          console.warn("Failed to include original photo:", err);
        }
      }

      // Contact & Bio
      payload.append("email", formData.personal.email);
      payload.append("phone", formData.personal.phone);

      payload.append("facebook", formData.contact.facebook);
      payload.append("twitter", formData.contact.twitter);
      payload.append("instagram", formData.contact.instagram);
      payload.append("homeTel", formData.contact.homeTel);
      payload.append("mobile", formData.contact.mobile);
      payload.append("website", formData.contact.website);

      payload.append("profession", formData.biographical.profession);
      payload.append("company", formData.biographical.company);
      payload.append("interests", formData.biographical.interests);
      payload.append("bioNotes", formData.biographical.bioNotes);
      payload.append("birthPlace", formData.biographical.birthPlace);
      payload.append("deathPlace", formData.biographical.deathPlace);

      const response = await axios.post(
        `${API_BASE_URL}/family/linkNewMember`,
        payload,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );

      toast.dismiss(registerToastId);
      toast.success("New member registered successfully!", { duration: 3000 });

      closeModal();
      onUpdateMembers(response.data.members || []);
    } catch (err) {
      console.error("Failed to register new member:", err);
      toast.error("Failed to register new member.", { id: registerToastId });
    }
  };

  const handleCancel = () => {
    toast.dismiss();
    closeModal();
  };

  return (
    <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl mx-auto p-4 sm:p-8 my-4 overflow-y-auto max-h-[90vh] relative">


      <button
        type="button"
        className="absolute top-4 right-4 text-gray-400 hover:text-red-500 text-2xl font-bold focus:outline-none"
        onClick={closeModal}
        aria-label="Close"
      >
        &times;
      </button>

      {selectedPerson &&   !editMode && (
        <div className="mb-6 p-4 rounded-lg bg-gray-50 border border-gray-200 flex items-center gap-4">
          <div className="w-14 h-16 rounded overflow-hidden bg-gray-200 flex items-center justify-center">
            <img
              src={
                selectedPerson.photo ||
                (selectedPerson.gender?.toUpperCase() === "MALE"
                  ? "/images/male-avatar.png"
                  : selectedPerson.gender?.toUpperCase() === "FEMALE"
                  ? "/images/female-avatar.png"
                  : "/images/default-avatar.png")
              }
              alt={selectedPerson.name}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.onerror = null; // 🔥 prevent infinite loop
                e.currentTarget.src = "/images/default-avatar.png";
              }}
            />
          </div>


          <div>
            <p className="text-xs text-gray-500 mb-1">Related To</p>
            <p className="text-sm font-semibold text-gray-800">{selectedPerson.name}</p>

            <p className="text-[11px] text-gray-500">
              You are adding a <span className="font-semibold">{formData.personal.relationType}</span> of {selectedPerson.name}
            </p>
          </div>
        </div>
      )}

      <h2 className="text-xl font-semibold text-gray-900 mb-6">
        {editMode ? "Edit Family Member" : "Register Family Member"}
      </h2>

      <div className="mb-6 border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {['Personal', 'Contact', 'Biographical'].map(tab => (
            <button
              key={tab}
              className={`whitespace-nowrap pb-2 px-1 border-b-2 text-sm font-medium transition-colors duration-200 ${
                activeTab === tab
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-blue-600 hover:border-blue-300'
              } ${existingUserMode && tab !== 'Personal' ? 'opacity-40 cursor-not-allowed' : ''}`}
              onClick={() => {
                if (existingUserMode && tab !== 'Personal') return;
                setActiveTab(tab);
              }}
              type="button"
            >
              {tab}
            </button>
          ))}
        </nav>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">

        {/* Personal */}
        {activeTab === 'Personal' && (
          <div className="space-y-4">

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className={existingUserMode ? 'sm:col-span-2' : ''}>
                <label className="block text-xs font-medium text-gray-700 mb-1" htmlFor="email">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={formData.personal.email}
                  onChange={handleEmailValidationChange}
                  onBlur={handleEmailUpdate}
                  className={`block w-full rounded-md border shadow-sm py-2 text-xs px-3 
                    ${errors.email ? "border-red-500" : "border-gray-300"}
                    focus:border-blue-500 focus:ring-blue-500`}
                  placeholder="Enter email"
                />

                {errors.email && (
                  <p className="text-[10px] text-red-600 mt-1">{errors.email}</p>
                )}
              </div>

              {!existingUserMode && (
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1" htmlFor="phone">
                    Mobile Phone
                  </label>
                  <input
                    type="text"
                    id="phone"
                    value={formData.personal.phone}
                    onChange={handlePhoneChange}
                    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                    placeholder="Enter phone"
                  />
                </div>
              )}
            </div>

            {/* Relation */}
            <div className="mb-3">
              <label htmlFor="relationType" className="block text-sm font-medium text-gray-700">
                Relation
              </label>
              <select 
                id="relationType"
                value={formData.personal.relationType}
                onChange={handlePersonalInfoChange}
                 disabled={editMode || isFirstMember}
                className={`block w-full border border-gray-300 rounded-md py-2 px-3 text-sm focus:ring-blue-500 focus:border-blue-500 ${
                  isFirstMember ? "bg-gray-100 cursor-not-allowed" : ""
                }`}
              >
                <option value="">Select relation</option>
                {relationOptions.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
              {isFirstMember && (
                <p className="text-xs text-green-600 mt-1">
                  This will be the root member of the family tree.
                </p>
              )}
            </div>

            {!existingUserMode && (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                  {/* First Name */}
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      First Name
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      value={formData.personal.firstName}
                      onChange={handleNameChange}
                      onBlur={validateForm}
                      placeholder="Enter First Name"
                      className={`block w-full rounded-md border py-2 text-xs px-3 shadow-sm 
                        ${errors.firstName ? "border-red-500" : "border-gray-300"}
                        focus:border-blue-500 focus:ring-blue-500`}
                    />
                    {errors.firstName && (
                      <p className="text-[10px] text-red-600 mt-1">{errors.firstName}</p>
                    )}
                  </div>

                  {/* Last Name */}
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Last Name
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      value={formData.personal.lastName}
                      onChange={handleNameChange}
                      onBlur={validateForm}
                      placeholder="Enter Last Name"
                      className={`block w-full rounded-md border py-2 text-xs px-3 shadow-sm
                        ${errors.lastName ? "border-red-500" : "border-gray-300"}
                        focus:border-blue-500 focus:ring-blue-500`}
                    />
                    {errors.lastName && (
                      <p className="text-[10px] text-red-600 mt-1">{errors.lastName}</p>
                    )}
                  </div>

                </div>

                {/* Gender / Alive */}
                <div className="flex flex-wrap items-center gap-6">
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="gender"
                      name="gender"
                      value="Female"
                      checked={formData.personal.gender === 'Female'}
                      onChange={handlePersonalInfoChange}
                      className="h-4 w-4 text-blue-600"
                    />
                    <label className="text-xs text-gray-700">Female</label>
                  </div>

                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="gender"
                      name="gender"
                      value="Male"
                      checked={formData.personal.gender === 'Male'}
                      onChange={handlePersonalInfoChange}
                      className="h-4 w-4 text-blue-600"
                    />
                    <label className="text-xs text-gray-700">Male</label>
                  </div>

                  <div className="flex items-center gap-2">
                    <label htmlFor="isAlive" className="text-xs text-gray-700">Alive</label>
                    <input
                      type="checkbox"
                      id="isAlive"
                      checked={formData.personal.isAlive}
                      onChange={handleAliveToggle}
                      className="h-4 w-4 text-blue-600"
                    />
                  </div>
                </div>

                {/* Dates */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div>
                    <label htmlFor="birthDate" className="block text-xs font-medium text-gray-700 mb-1">Birth Date</label>
                    <input
                      type="date"
                      id="birthDate"
                      value={formData.personal.birthDate}
                      onChange={handlePersonalInfoChange}
                      max={today}
                      className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label htmlFor="marriageDate" className="block text-xs font-medium text-gray-700 mb-1">Marriage Date</label>
                    <input
                      type="date"
                      id="marriageDate"
                      value={formData.personal.marriageDate}
                      onChange={handlePersonalInfoChange}
                      className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                   {/* ✅ Only show Death Date when NOT alive */}
                    {!formData.personal.isAlive && (
                      <div>
                        <label htmlFor="deathDate" className="block text-xs font-medium text-gray-700 mb-1">Death Date</label>
                        <input
                          type="date"
                          id="deathDate"
                          value={formData.personal.deathDate}
                          onChange={handlePersonalInfoChange}
                          max={today}
                          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                        />
                      </div>
                    )}
                </div>

                {/* Photo */}
                <div>
                  <label htmlFor="photo" className="block text-xs font-medium text-gray-700 mb-1">
                    Photo
                  </label>

                  {!cropping && (
                    <div className="flex flex-col items-center gap-2">
                        <img
                          src={
                            formData.personal.croppedPhoto ||
                            formData.personal.photo ||
                            (formData.personal.gender?.toUpperCase() === "MALE"
                              ? "/images/male-avatar.png"
                              : formData.personal.gender?.toUpperCase() === "FEMALE"
                              ? "/images/female-avatar.png"
                              : "/images/default-avatar.png")
                          }
                          alt="Profile"
                          className="w-24 h-24 rounded-full object-cover"
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = "/images/default-avatar.png";
                          }}
                        />


                      <label
                        htmlFor="photo"
                        className="inline-flex items-center justify-center w-full px-4 py-2 text-xs font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 cursor-pointer"
                      >
                        Update Image
                        <input
                          type="file"
                          id="photo"
                          className="hidden"
                          onChange={handlePersonalInfoChange}
                          accept="image/*"
                        />
                      </label>
                    </div>
                  )}

                  {formData.personal.photo && cropping && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                      <div className="bg-white rounded-lg p-4 w-full max-w-md">
                        <div className="relative w-full h-64 bg-gray-100">
                          <Cropper
                            image={formData.personal.photo}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={handleCropComplete}
                          />
                        </div>
                        <div className="flex justify-end gap-2 mt-4">
                          <button
                            type="button"
                            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
                            onClick={handleCropCancel}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white"
                            onClick={handleCropSave}
                          >
                            Crop & Save
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

              </>
            )}

          </div>
        )}

        {/* Contact */}
        {activeTab === 'Contact' && !existingUserMode && (
          <div className="space-y-4">
            <div>
              <label htmlFor="facebook" className="block text-xs font-medium text-gray-700 mb-1">Facebook URL</label>
              <input
                type="text"
                id="facebook"
                value={formData.contact.facebook}
                onChange={handleContactInfoChange}
                placeholder="https://facebook.com/user"
                className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
              />
            </div>

            <div>
              <label htmlFor="twitter" className="block text-xs font-medium text-gray-700 mb-1">Twitter Handle</label>
              <input
                type="text"
                id="twitter"
                value={formData.contact.twitter}
                onChange={handleContactInfoChange}
                placeholder="@handle"
                className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
              />
            </div>

            <div>
              <label htmlFor="instagram" className="block text-xs font-medium text-gray-700 mb-1">Instagram Handle</label>
              <input
                type="text"
                id="instagram"
                value={formData.contact.instagram}
                onChange={handleContactInfoChange}
                placeholder="@handle"
                className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="homeTel" className="block text-xs font-medium text-gray-700 mb-1">Home Telephone</label>
                <input
                  type="text"
                  id="homeTel"
                  value={formData.contact.homeTel}
                  onChange={handleContactInfoChange}
                  placeholder="(123) 456-7890"
                  className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div>
              <label htmlFor="website" className="block text-xs font-medium text-gray-700 mb-1">Website URL</label>
              <input
                type="url"
                id="website"
                value={formData.contact.website}
                onChange={handleContactInfoChange}
                placeholder="https://www.example.com"
                className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
              />
            </div>
          </div>
        )}

        {/* Biographical */}
        {activeTab === 'Biographical' && !existingUserMode && (
          <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="profession" className="block text-xs font-medium text-gray-700 mb-1">Profession</label>
                <input
                  type="text"
                  id="profession"
                  value={formData.biographical.profession}
                  onChange={handleBiographicalInfoChange}
                  placeholder="e.g., Engineer"
                  className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>

              <div>
                <label htmlFor="company" className="block text-xs font-medium text-gray-700 mb-1">Company</label>
                <input
                  type="text"
                  id="company"
                  value={formData.biographical.company}
                  onChange={handleBiographicalInfoChange}
                  placeholder="e.g., Tech Solutions Inc."
                  className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="birthPlace" className="block text-xs font-medium text-gray-700 mb-1">Birth Place</label>
                <input
                  type="text"
                  id="birthPlace"
                  value={formData.biographical.birthPlace}
                  onChange={handleBiographicalInfoChange}
                  placeholder="City, State/Country"
                  className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              {!formData.personal.isAlive && (
                <div>
                  <label htmlFor="deathPlace" className="block text-xs font-medium text-gray-700 mb-1">Death Place</label>
                  <input
                    type="text"
                    id="deathPlace"
                    value={formData.biographical.deathPlace}
                    onChange={handleBiographicalInfoChange}
                    disabled={formData.personal.isAlive}
                    placeholder="City, State/Country"
                    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
              )}
            </div>

            <div>
              <label htmlFor="interests" className="block text-xs font-medium text-gray-700 mb-1">Interests</label>
              <textarea
                id="interests"
                value={formData.biographical.interests}
                onChange={handleBiographicalInfoChange}
                rows="2"
                placeholder="Hobbies, clubs, favorite activities..."
                className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
              />
            </div>

            <div>
              <label htmlFor="bioNotes" className="block text-xs font-medium text-gray-700 mb-1">Biographical Notes</label>
              <textarea
                id="bioNotes"
                value={formData.biographical.bioNotes}
                onChange={handleBiographicalInfoChange}
                rows="3"
                placeholder="Any special notes or life details."
                className="block w-full rounded-md border border-gray-300 shadow-sm py-2 text-xs px-3 focus:border-blue-500 focus:ring-blue-500"
              />
            </div>
          </div>
        )}

        {/* Buttons */}
        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            onClick={handleCancel}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-2 px-6 rounded-md"
          >
            Cancel
          </button>

          <button
            type="submit"
            disabled={!formValid}
            className={`
              ${existingUserMode ? 'bg-green-600 hover:bg-green-700' : 'bg-blue-600 hover:bg-blue-700'}
              text-white font-semibold py-2 px-6 rounded-md
              ${!formValid ? "opacity-40 cursor-not-allowed" : ""}
            `}
          >
            {existingUserMode ? 'Link User' : 'Submit'}
          </button>
        </div>

      </form>
    </div>
  );
}

export default RegisterMember;
